<template>
  <view-frame :class="$style.Modal">
    <view-header :title="title" :back="back"></view-header>
    <view-body ref="ViewBody" class="p-4">
      <slot />
    </view-body>
    <view-footer>
      <slot name="footer" />
    </view-footer>
  </view-frame>
</template>
<script>
import ViewFrame from '../views/fragments/ViewFrame.vue';
import ViewHeader from '../views/fragments/ViewHeader.vue';
import ViewBody from '../views/fragments/ViewBody.vue';
import ViewFooter from '../views/fragments/ViewFooter.vue';

export default {
  name: 'Modal',
  components: {
    ViewFrame,
    ViewHeader,
    ViewBody,
    ViewFooter
  },
  props: {
    title: {
      type: String,
      required: true
    },
    back: {
      type: String,
      default: null,
      required: false
    }
  },
  mounted() {
    this.$root.$on('scrollModalToTop', () => {
      if (this.$refs.ViewBody && this.$refs.ViewBody.$el)
        this.$refs.ViewBody.$el.scrollTop = 0;
    });
  }
};
</script>
<style lang="scss" module scoped>
.Modal {
  @apply absolute pin-l bg-white pin-t w-full h-full;
  z-index: 980;

  h1,
  h2,
  h3,
  h4,
  h5,
  h6 {
    &:first-child {
      @apply mt-0 pt-0;
    }
  }

  ul {
    @apply mt-2 mb-0 mr-2;
  }
}

@screen md {
  .Modal {
    @apply ml-32 w-112 h-full;
  }
}
</style>
